import { render, staticRenderFns } from "./LoadingModal.vue?vue&type=template&id=63c9fb7a&"
import script from "./LoadingModal.vue?vue&type=script&lang=ts&"
export * from "./LoadingModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports